import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTicketsV2 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2737 7.15078L18.8041 7.68111C19.097 7.38822 19.097 6.91334 18.8041 6.62045L18.2737 7.15078ZM21.1022 9.97921L21.6325 9.44888C21.3396 9.15598 20.8647 9.15598 20.5718 9.44888L21.1022 9.97921ZM14.2079 5.91334L7.13681 12.9844L8.19747 14.0451L15.2685 6.974L14.2079 5.91334ZM18.097 5.91334C17.023 4.8394 15.2818 4.8394 14.2079 5.91334L15.2685 6.974C15.7567 6.48585 16.5482 6.48585 17.0363 6.974L18.097 5.91334ZM18.8041 6.62045L18.097 5.91334L17.0363 6.974L17.7434 7.68111L18.8041 6.62045ZM17.7434 6.62045C16.6695 7.69439 16.6695 9.4356 17.7434 10.5095L18.8041 9.44888C18.3159 8.96072 18.3159 8.16927 18.8041 7.68111L17.7434 6.62045ZM17.7434 10.5095C18.8174 11.5835 20.5586 11.5835 21.6325 10.5095L20.5718 9.44888C20.0837 9.93703 19.2922 9.93703 18.8041 9.44888L17.7434 10.5095ZM22.3396 10.156L21.6325 9.44888L20.5718 10.5095L21.2789 11.2166L22.3396 10.156ZM22.3396 14.0451C23.4136 12.9711 23.4136 11.2299 22.3396 10.156L21.2789 11.2166C21.7671 11.7048 21.7671 12.4963 21.2789 12.9844L22.3396 14.0451ZM20.9254 15.4593L22.3396 14.0451L21.2789 12.9844L19.8647 14.3986L20.9254 15.4593ZM15.2685 21.1161L20.9254 15.4593L19.8647 14.3986L14.2079 20.0555L15.2685 21.1161ZM11.3795 21.1161C12.4534 22.1901 14.1946 22.1901 15.2685 21.1161L14.2079 20.0555C13.7197 20.5436 12.9283 20.5436 12.4401 20.0555L11.3795 21.1161ZM9.5301 19.2668L11.3795 21.1161L12.4401 20.0555L10.5908 18.2061L9.5301 19.2668ZM7.13681 16.8735L9.5301 19.2668L10.5908 18.2061L8.19747 15.8128L7.13681 16.8735ZM7.13681 12.9844C6.06287 14.0584 6.06287 15.7996 7.13681 16.8735L8.19747 15.8128C7.70932 15.3247 7.70932 14.5332 8.19747 14.0451L7.13681 12.9844Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9482 8.64502L19.6583 15.3551",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeDasharray: "3 3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.96582 18.1143L5.48286 17.9849C4.41593 17.699 3.78276 16.6024 4.06864 15.5354L6.65684 5.87617C6.94272 4.80924 8.03939 4.17607 9.10632 4.46196L10.0723 4.72077C9.868 5.48306 10.1329 6.26053 10.6899 6.74664",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.96777 8.86865L7.25676 9.21404M10.6296 10.1171L9.5877 9.83824",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgTicketsV2);
export default ForwardRef;
